module.exports = __webpack_public_path__ + "static/media/background.48854869.jpg";